import type { ManualClPoolTicksResponseItem } from "@/domains/validators"

import type { ManualClGraphQlService } from "../manual-cl-graphql-service"

/**
 * Thin wrapper around `ManualClGraphQlService.getPoolTicks`.
 *
 * Purpose: decouple the orchestrator from schema parsing details so tests can
 * stub a minimal `loadTicks(poolAddress, chainId)` shape. The chainId is
 * required because the indexer's `Tick.poolAddress` column is the composite
 * pool ID (`<address>-<chainId>`), not the raw EVM address.
 */
export class ThickV2TickDistributionGraphQlTransport {
  constructor(private readonly graphQlService: ManualClGraphQlService) {}

  async loadTicks(
    poolAddress: string,
    chainId: number,
  ): Promise<Array<ManualClPoolTicksResponseItem>> {
    const ticks = await this.graphQlService.getPoolTicks(poolAddress, chainId)
    return ticks ?? []
  }
}
